﻿/**
* DevExpress Analytics (query-builder\dataSource\dbSchema.js)
* Version:  21.2.8
* Build date: Jun 7, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dbTable_1 = require("./dbTable");
var dbStoredProcedure_1 = require("./dbStoredProcedure");
var _dbSchema_1 = require("./_dbSchema");
var DBSchema = (function () {
    function DBSchema(model) {
        var tables = _dbSchema_1.deserializeToCollection(model['Tables'], function (tableModel) { return new dbTable_1.DBTable(tableModel); });
        tables.sort(function (a, b) { return a.name.localeCompare(b.name); });
        var views = _dbSchema_1.deserializeToCollection(model['Views'], function (tableModel) { return new dbTable_1.DBTable(tableModel); });
        views.sort(function (a, b) { return a.name.localeCompare(b.name); });
        this.tables = tables.concat(views);
        this.procedures = _dbSchema_1.deserializeToCollection(model['StoredProcedures'], function (procModel) { return new dbStoredProcedure_1.DBStoredProcedure(procModel); });
    }
    return DBSchema;
}());
exports.DBSchema = DBSchema;
